import { render } from "./AvailableWorksView.vue?vue&type=template&id=587ecada"
import script from "./AvailableWorksView.vue?vue&type=script&lang=js"
export * from "./AvailableWorksView.vue?vue&type=script&lang=js"

import "./AvailableWorksView.vue?vue&type=style&index=0&id=587ecada&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__